import { useRouter } from 'next/router';
import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

export const useRouteChangeTab = (tabInfo: Record<string, number>) => {
  const router = useRouter();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const tabTitles = useMemo(
    () => Object.keys(tabInfo),
    [tabInfo],
  );

  const handleRouteChangeTab = useCallback((index: number) => {
    const title = tabTitles.find((key) => tabInfo[key] === index);
    router.push({
      query: {
        tab: title,
      },
    });
  }, [router, tabTitles, tabInfo]);

  useEffect(() => {
    const tab = router.query.tab || tabTitles[0];
    if (typeof tab !== 'string') return;

    if (tabTitles.includes(tab)) {
      setSelectedTabIndex(tabInfo[tab]);
    } else {
      router.replace(router.pathname, undefined, { shallow: true });
    }
  }, [router, tabTitles, tabInfo]);

  return {
    selectedTabIndex,
    handleRouteChangeTab,
  };
};
